// Converts BR date (DD/MM/YYYY) to ISO date (YYYY-MM-DD)
export function brDateToISO(value = '') {
  const str = String(value).trim();
  const parts = str.split('/');
  if (parts.length !== 3) return '';
  const [dd, mm, yyyy] = parts;
  if (!dd || !mm || !yyyy) return '';
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}
